import React from "react"
import { Alert } from "react-bootstrap"
import { useSelector } from "react-redux"
import _ from "lodash"

import { getSelectedProduct } from "@/onboarding/features/cost_analysis/selectors"

// A component whose ratesheet does not quote a passenger type is costed at $0
// for those passengers, which reads as a quoted $0 or a saving unless said.
const UnquotedRatesWarning = (): JSX.Element => {
  const { unquotedRates } = useSelector(getSelectedProduct)

  if (_.isEmpty(unquotedRates)) return null

  return (
    <Alert variant="warning" className="mb-0">
      <p>
        Some components do not quote a rate for every passenger type. Their totals and variances
        count those passengers at $0 and may be inaccurate:
      </p>
      <ul className="mb-0">
        {unquotedRates.map(({ category, component, quotedBy, missing }) => (
          <li key={`${quotedBy}/${category}/${component}`}>
            {`${category}: ${component} (${quotedBy || "requested"}): no ${missing.join(", ")} rate`}
          </li>
        ))}
      </ul>
    </Alert>
  )
}

export default UnquotedRatesWarning
